import VanillaMask from 'vanilla-masker'

export const formatMoney = (value = '0', options = {}) => {
  const defaultOptions = {
    showSignal: true,
    precision: 2,
    separator: ',',
    delimiter: '.',
    unit: 'R$',
    zeroCents: false
  };

  const mergedOptions = { ...defaultOptions, ...options };

  return VanillaMask.toMoney(value, {
    showSignal: mergedOptions.showSignal,
    precision: mergedOptions.precision,
    separator: mergedOptions.separator,
    delimiter: mergedOptions.delimiter,
    unit: mergedOptions.unit,
    zeroCents: mergedOptions.zeroCents
  });
};

export const formatDecimal = (value = '0', precision = 1) => VanillaMask.toMoney(value, {
  showSignal: true,
  precision,
  separator: ',',
  delimiter: '.',
  unit: '',
  zeroCents: false
})

export const toLocaleMoney = (value = 0 ) => {
  const UNICODE_NON_BREAKING_SPACE = String.fromCharCode(160)
  const USUAL_SPACE = String.fromCharCode(32)
  const MONEY_MASK = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
  return String(MONEY_MASK
    .format(value))
    .replace(UNICODE_NON_BREAKING_SPACE, USUAL_SPACE)
}

export const formatToNumber = value => {
  if (typeof value === 'string') {
    return parseFloat(value.replace("R$", "").replace(".", "").replace(",", ".")).toFixed(2)
  } else {
    return value
  }
}

export const formatToExibition = value => value.toFixed(2).replace(".", ",")

export const convertToNegative = value =>
  value > 0
    ? Math.abs(value) * -1
    : value
